import * as type from "../types/company";

const initialState = {
  details: {
    thumbnail: null,
    name: null,
    city: null,
    industry: null,
  },
  team: [],
  receipts: [],
  subscription: {
    main: null,
    other: [],
  },
  paymentMethods: [],
  channels: [],
  fetchDetails: {
    error: null,
    loading: true,
  },
  fetchThumbnail: {
    status: null,
    loading: false,
    error: null,
  },
  updateThumbnail: {
    status: null,
    loading: false,
    error: null,
  },
  deleteThumbnail: {
    status: null,
    loading: false,
    error: null,
  },
  fetchFullTeam: {
    error: null,
    loading: false,
  },
  fetchReceipts: {
    error: null,
    loading: false,
  },
  fetchSubscription: {
    error: null,
    loading: false,
  },
  deleteSubscription: {
    status: null,
    loading: false,
    error: null,
  },
  sendInvitation: {
    status: null,
    loading: false,
    error: null,
  },
  deleteCompany: {
    status: null,
    loading: false,
    error: null,
  },
  deleteMember: {
    status: null,
    loading: false,
    error: null,
  },
  changeMember: {
    status: null,
    loading: false,
    error: null,
  },
  activeMember: null,
  activeEdit: {
    id: null,
    role: null,
  },
  activeSubscription: {
    id: null,
    type: null,
    channels: null,
  },
  activePaymentMethod: {
    id: null,
    brand: null,
    exp_month: null,
    exp_year: null,
    last4: null,
    name: null,
  },
  updateDetails: {
    status: null,
    loading: false,
    error: null,
  },
  fetchPaymentMethods: {
    status: null,
    loading: false,
    error: null,
  },
  deletePaymentMethod: {
    status: null,
    loading: false,
    error: null,
  },
  addPaymentMethod: {
    status: null,
    loading: false,
    error: null,
  },
  updatePaymentMethod: {
    status: null,
    loading: false,
    error: null,
  },
  updateLicenseQuantity: {
    status: null,
    loading: false,
    error: null,
  },
  fetchChannels: {
    status: null,
    loading: false,
    error: null,
  },
  showModals: {
    addMember: false,
    addEmailChannel: false,
    editModal: false,
    deleteSpace: false,
    cancelSubscription: false,
    newModal: false,
    removeMember: false,
    removePaymentMethod: false,
    addPaymentMethod: false,
    updatePaymentMethod: false,
    changeMainSubscription: false,
  },
};

export const company = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_COMPANY_DETAILS:
      return {
        ...state,
        fetchDetails: {
          ...state.fetchDetails,
          error: null,
          loading: true,
        },
      };
    case type.REVOKE_COMPANY_DETAILS:
      return {
        ...state,
        details: {},
        fetchDetails: {
          ...state.fetchDetails,
          error: payload.message,
          loading: false,
        },
      };
    case type.SET_COMPANY_DETAILS:
      return {
        ...state,
        details: payload.details,
        fetchDetails: {
          ...state.fetchDetails,
          error: null,
          loading: false,
        },
      };
    case type.RESET_COMPANY_DETAILS:
      return {
        ...state,
        details: {},
        fetchDetails: {
          ...state.fetchDetails,
          error: null,
          loading: true,
        },
      };
    case type.CHANGE_COMPANY_MODALS:
      if (
        payload.modal.addMember === true ||
        payload.modal.addMember === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addMember: payload.modal.addMember,
          },
        };
      } else if (
        payload.modal.editModal === true ||
        payload.modal.editModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editModal: payload.modal.editModal,
          },
        };
      } else if (
        payload.modal.deleteSpace === true ||
        payload.modal.deleteSpace === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            deleteSpace: payload.modal.deleteSpace,
          },
        };
      } else if (
        payload.modal.cancelSubscription === true ||
        payload.modal.cancelSubscription === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            cancelSubscription: payload.modal.cancelSubscription,
          },
        };
      } else if (
        payload.modal.newModal === true ||
        payload.modal.newModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            newModal: payload.modal.newModal,
          },
        };
      } else if (
        payload.modal.removeMember === true ||
        payload.modal.removeMember === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            removeMember: payload.modal.removeMember,
          },
        };
      } else if (
        payload.modal.changeRole === true ||
        payload.modal.changeRole === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            changeRole: payload.modal.changeRole,
          },
        };
      } else if (
        payload.modal.removePaymentMethod === true ||
        payload.modal.removePaymentMethod === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            removePaymentMethod: payload.modal.removePaymentMethod,
          },
        };
      } else if (
        payload.modal.addPaymentMethod === true ||
        payload.modal.addPaymentMethod === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addPaymentMethod: payload.modal.addPaymentMethod,
          },
        };
      } else if (
        payload.modal.updatePaymentMethod === true ||
        payload.modal.updatePaymentMethod === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            updatePaymentMethod: payload.modal.updatePaymentMethod,
          },
        };
      } else if (
        payload.modal.changeMainSubscription === true ||
        payload.modal.changeMainSubscription === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            changeMainSubscription: payload.modal.changeMainSubscription,
          },
        };
      } else if (
        payload.modal.addChannel === true ||
        payload.modal.addChannel === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addChannel: payload.modal.addChannel,
          },
        };
      } else {
        return state;
      }
    case type.REQUEST_UPDATE_COMPANY_IMAGE:
      return {
        ...state,
        updateThumbnail: {
          ...state.updateThumbnail,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_COMPANY_IMAGE:
      return {
        ...state,
        updateThumbnail: {
          ...state.updateThumbnail,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_COMPANY_IMAGE:
      return {
        ...state,
        updateThumbnail: {
          ...state.updateThumbnail,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_COMPANY_IMAGE:
      return {
        ...state,
        updateThumbnail: {
          ...state.updateThumbnail,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_DELETE_COMPANY_IMAGE:
      return {
        ...state,
        deleteThumbnail: {
          ...state.deleteThumbnail,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_COMPANY_IMAGE:
      return {
        ...state,
        deleteThumbnail: {
          ...state.deleteThumbnail,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_DELETE_COMPANY_IMAGE:
      return {
        ...state,
        deleteThumbnail: {
          ...state.deleteThumbnail,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_DELETE_COMPANY_IMAGE:
      return {
        ...state,
        deleteThumbnail: {
          ...state.deleteThumbnail,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_COMPANY_IMAGE:
      return {
        ...state,
        fetchThumbnail: {
          ...state.fetchThumbnail,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_COMPANY_IMAGE:
      return {
        ...state,
        fetchThumbnail: {
          ...state.fetchThumbnail,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_COMPANY_IMAGE:
      return {
        ...state,
        details: {
          ...state.details,
          thumbnail: payload.image,
        },
        fetchThumbnail: {
          ...state.fetchThumbnail,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_COMPANY_IMAGE:
      return {
        ...state,
        fetchThumbnail: {
          ...state.fetchThumbnail,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_COMPANY_TEAM:
      return {
        ...state,
        team: [],
        fetchFullTeam: {
          ...state.fetchFullTeam,
          loading: true,
          error: null,
        },
      };
    case type.SET_COMPANY_TEAM:
      return {
        ...state,
        team: payload.details,
        fetchFullTeam: {
          ...state.fetchFullTeam,
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_COMPANY_TEAM:
      return {
        ...state,
        team: [],
        fetchFullTeam: {
          ...state.fetchFullTeam,
          loading: false,
          error: payload.details,
        },
      };
    case type.RESET_COMPANY_TEAM:
      return {
        ...state,
        team: [],
        fetchFullTeam: {
          ...state.fetchFullTeam,
          loading: true,
          error: null,
        },
      };
    case type.REQUEST_COMPANY_RECEIPTS:
      return {
        ...state,
        receipts: [],
        fetchReceipts: {
          ...state.fetchReceipts,
          loading: true,
          error: null,
        },
      };
    case type.SET_COMPANY_RECEIPTS:
      return {
        ...state,
        receipts: payload.details,
        fetchReceipts: {
          ...state.fetchReceipts,
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_COMPANY_RECEIPTS:
      return {
        ...state,
        receipts: [],
        fetchReceipts: {
          ...state.fetchReceipts,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_COMPANY_RECEIPTS:
      return {
        ...state,
        receipts: [],
        fetchReceipts: {
          ...state.fetchReceipts,
          loading: true,
          error: null,
        },
      };
    case type.REQUEST_COMPANY_SUBSCRIPTION:
      return {
        ...state,
        subscription: {
          main: null,
          other: [],
        },
        fetchSubscription: {
          ...state.fetchSubscription,
          loading: true,
          error: null,
        },
      };
    case type.SET_COMPANY_SUBSCRIPTION:
      return {
        ...state,
        subscription: payload.details,
        fetchSubscription: {
          ...state.fetchSubscription,
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_COMPANY_SUBSCRIPTION:
      return {
        ...state,
        subscription: {
          main: null,
          other: [],
        },
        fetchSubscription: {
          ...state.fetchSubscription,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_COMPANY_SUBSCRIPTION:
      return {
        ...state,
        subscription: {
          main: null,
          other: [],
        },
        fetchSubscription: {
          ...state.fetchSubscription,
          loading: true,
          error: null,
        },
      };
    case type.REQUEST_SUBSCRIPTION_DELETION:
      return {
        ...state,
        deleteSubscription: {
          ...state.deleteSubscription,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_SUBSCRIPTION_DELETION:
      return {
        ...state,
        deleteSubscription: {
          ...state.deleteSubscription,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SUBSCRIPTION_DELETION:
      return {
        ...state,
        deleteSubscription: {
          ...state.deleteSubscription,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_SUBSCRIPTION_DELETION:
      return {
        ...state,
        deleteSubscription: {
          ...state.deleteSubscription,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_SEND_INVITATION:
      return {
        ...state,
        sendInvitation: {
          ...state.sendInvitation,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_SEND_INVITATION:
      return {
        ...state,
        sendInvitation: {
          ...state.sendInvitation,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SEND_INVITATION:
      return {
        ...state,
        sendInvitation: {
          ...state.sendInvitation,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_SEND_INVITATION:
      return {
        ...state,
        sendInvitation: {
          ...state.sendInvitation,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_DELETE_COMPANY:
      return {
        ...state,
        deleteCompany: {
          ...state.deleteCompany,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_DELETE_COMPANY:
      return {
        ...state,
        deleteCompany: {
          ...state.deleteCompany,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_DELETE_COMPANY:
      return {
        ...state,
        deleteCompany: {
          ...state.deleteCompany,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_DELETE_COMPANY:
      return {
        ...state,
        deleteCompany: {
          ...state.deleteCompany,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_DELETE_MEMBER:
      return {
        ...state,
        deleteMember: {
          ...state.deleteMember,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_DELETE_MEMBER:
      return {
        ...state,
        deleteMember: {
          ...state.deleteMember,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_DELETE_MEMBER:
      return {
        ...state,
        deleteMember: {
          ...state.deleteMember,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_DELETE_MEMBER:
      return {
        ...state,
        deleteMember: {
          ...state.deleteMember,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.SET_ACTIVE_EDIT_MEMBER:
      return {
        ...state,
        activeEdit: {
          ...state.activeEdit,
          id: payload.details.id ? payload.details.id : null,
          role: payload.details.role ? payload.details.role : null,
        },
      };
    case type.RESET_ACTIVE_EDIT_MEMBER:
      return {
        ...state,
        activeEdit: {
          id: null,
          role: null,
        },
      };
    case type.SET_ACTIVE_SUBSCRIPTION:
      return {
        ...state,
        activeSubscription: {
          ...state.activeSubscription,
          id: payload.details.id ? payload.details.id : null,
          type: payload.details.type ? payload.details.type : null,
          channels: payload.details.channels ? payload.details.channels : null,
        },
      };
    case type.RESET_ACTIVE_SUBSCRIPTION:
      return {
        ...state,
        activeSubscription: {
          id: null,
          type: null,
        },
      };
    case type.REQUEST_CHANGE_MEMBER:
      return {
        ...state,
        changeMember: {
          ...state.changeMember,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_CHANGE_MEMBER:
      return {
        ...state,
        changeMemberError: null,
        changeMemberLoading: false,
        changeMemberStatus: "success",
      };
    case type.REVOKE_CHANGE_MEMBER:
      return {
        ...state,
        changeMemberError: payload.message,
        changeMemberLoading: false,
        changeMemberStatus: null,
      };
    case type.RESET_CHANGE_MEMBER:
      return {
        ...state,
        changeMemberError: null,
        changeMemberLoading: false,
        changeMemberStatus: null,
      };
    case type.REQUEST_UPDATE_COMPANY_DETAILS:
      return {
        ...state,
        updateDetails: {
          ...state.updateDetails,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_COMPANY_DETAILS:
      return {
        ...state,
        updateDetails: {
          ...state.updateDetails,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_COMPANY_DETAILS:
      return {
        ...state,
        updateDetails: {
          ...state.updateDetails,
          status: payload.details,
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_COMPANY_DETAILS:
      return {
        ...state,
        updateDetails: {
          ...state.updateDetails,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_COMPANY_PAYMENT_METHODS:
      return {
        ...state,
        paymentMethods: {},
        fetchPaymentMethods: {
          ...state.fetchPaymentMethods,
          loading: true,
          error: null,
        },
      };
    case type.SET_COMPANY_PAYMENT_METHODS:
      return {
        ...state,
        paymentMethods: payload.details,
        fetchPaymentMethods: {
          ...state.fetchPaymentMethods,
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_COMPANY_PAYMENT_METHODS:
      return {
        ...state,
        paymentMethods: {},
        fetchPaymentMethods: {
          ...state.fetchPaymentMethods,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_COMPANY_PAYMENT_METHODS:
      return {
        ...state,
        paymentMethods: {},
        fetchPaymentMethods: {
          ...state.fetchPaymentMethods,
          loading: true,
          error: null,
        },
      };
    case type.SET_ACTIVE_PAYMENT_METHOD:
      return {
        ...state,
        activePaymentMethod: payload.details,
      };
    case type.RESET_ACTIVE_PAYMENT_METHOD:
      return {
        ...state,
        activePaymentMethod: {
          id: null,
          role: null,
        },
      };
    case type.REQUEST_DELETE_PAYMENT_METHOD:
      return {
        ...state,
        deletePaymentMethod: {
          ...state.deletePaymentMethod,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_DELETE_PAYMENT_METHOD:
      return {
        ...state,
        deletePaymentMethod: {
          ...state.deletePaymentMethod,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_DELETE_PAYMENT_METHOD:
      return {
        ...state,
        deletePaymentMethod: {
          ...state.deletePaymentMethod,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_DELETE_PAYMENT_METHOD:
      return {
        ...state,
        deletePaymentMethod: {
          ...state.deletePaymentMethod,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_ADD_PAYMENT_METHOD:
      return {
        ...state,
        addPaymentMethod: {
          ...state.addPaymentMethod,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_ADD_PAYMENT_METHOD:
      return {
        ...state,
        addPaymentMethod: {
          ...state.addPaymentMethod,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_ADD_PAYMENT_METHOD:
      return {
        ...state,
        addPaymentMethod: {
          ...state.addPaymentMethod,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ADD_PAYMENT_METHOD:
      return {
        ...state,
        addPaymentMethod: {
          ...state.addPaymentMethod,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATE_PAYMENT_METHOD:
      return {
        ...state,
        updatePaymentMethod: {
          ...state.updatePaymentMethod,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_UPDATE_PAYMENT_METHOD:
      return {
        ...state,
        updatePaymentMethod: {
          ...state.updatePaymentMethod,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_PAYMENT_METHOD:
      return {
        ...state,
        updatePaymentMethod: {
          ...state.updatePaymentMethod,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_UPDATE_PAYMENT_METHOD:
      return {
        ...state,
        updatePaymentMethod: {
          ...state.updatePaymentMethod,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATE_LICENSE_QUANTITY:
      return {
        ...state,
        updateLicenseQuantity: {
          ...state.updateLicenseQuantity,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_UPDATE_LICENSE_QUANTITY:
      return {
        ...state,
        updateLicenseQuantity: {
          ...state.updateLicenseQuantity,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_LICENSE_QUANTITY:
      return {
        ...state,
        updateLicenseQuantity: {
          ...state.updateLicenseQuantity,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_UPDATE_LICENSE_QUANTITY:
      return {
        ...state,
        updateLicenseQuantity: {
          ...state.updateLicenseQuantity,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_COMPANY_CHANNELS:
      return {
        ...state,
        channels: [],
        fetchChannels: {
          ...state.fetchChannels,
          loading: true,
          error: null,
        },
      };
    case type.SET_COMPANY_CHANNELS:
      return {
        ...state,
        channels: payload.details,
        fetchChannels: {
          ...state.fetchChannels,
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_COMPANY_CHANNELS:
      return {
        ...state,
        channels: [],
        fetchChannels: {
          ...state.fetchChannels,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_COMPANY_CHANNELS:
      return {
        ...state,
        channels: [],
        fetchChannels: {
          ...state.fetchChannels,
          loading: true,
          error: null,
        },
      };
    default:
      return state;
  }
};
